export const aliyunVideoReg = /^[a-zA-Z0-9]+\/[^/]+\.\w+\?.*$/u

export const ratioReg = /^\d*:\d*$/u
